import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Paper or electrons",
  "description": "",
  "published": "2007-03-20T00:00:00.000Z",
  "redirect_from": ["/blog/paper-or-electrons/swizec/257"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Was really looking forward to making today's blog a review of `}<a parentName="p" {...{
        "href": "http://www.steampunkmagazine.com/"
      }}>{`SteamPunk Magazine`}</a>{`, but it so happened that I haven't really managed to read it yet so all I can say about it thusfar is that it's a rather nicely built item with some very solid reading and interesting things. It's so interesting as to get stolen by a classmate ... If you're looking into reading this, you should go paper because electrons just don't do it justice.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      